(() => {
  const anchorSectionSelector = ".bls__product-tabs--anchor";

  const getHeaderOffset = () => {
    const headerSection = document.querySelector(".section-header");
    const stickyHeader = document.getElementById("header-sticky");
    const header = headerSection?.querySelector("header[data-sticky]");

    if (!headerSection || !stickyHeader || !header) return 0;
    if (header.dataset.sticky === "none") return 0;
    if (window.innerWidth < 1025 && header.dataset.stickyMobile === "false") {
      return 0;
    }
    if (headerSection.classList.contains("shopify-section-header-hidden")) {
      return 0;
    }

    if (header.dataset.sticky === "always") return stickyHeader.offsetHeight;

    return headerSection.classList.contains("shopify-section-header-sticky")
      ? stickyHeader.offsetHeight
      : 0;
  };

  const initAnchorNavigation = (section) => {
    if (!section) return;

    section.__zqProductAnchorController?.abort();

    const nav = section.querySelector(".zq-product-anchor-nav");
    const list = section.querySelector(".zq-product-anchor-nav__list");
    const sections = Array.from(
      section.querySelectorAll("[data-anchor-section]:not(.hidden)")
    );
    const links = Array.from(
      section.querySelectorAll("[data-anchor-link]")
    ).filter(
      (link) =>
        !link.closest(".zq-product-anchor-nav__item")?.classList.contains("hidden")
    );

    if (!nav || !list || !sections.length || !links.length) return;

    const controller = new AbortController();
    const { signal } = controller;
    section.__zqProductAnchorController = controller;
    let frameRequested = false;
    let activeId = "";

    const updateMeasurements = () => {
      const headerOffset = getHeaderOffset();
      const navGap = window.innerWidth < 768 ? 8 : 0;
      section.style.setProperty("--zq-product-anchor-top", `${headerOffset}px`);
      section.style.setProperty("--zq-product-anchor-gap", `${navGap}px`);
      section.style.setProperty(
        "--zq-product-anchor-measured-height",
        `${nav.offsetHeight}px`
      );
      nav.classList.toggle(
        "is-stuck",
        Math.abs(nav.getBoundingClientRect().top - headerOffset - navGap) <= 2 &&
          section.getBoundingClientRect().top < headerOffset
      );
      return { headerOffset, navGap };
    };

    const centerActiveLink = (link) => {
      const listRect = list.getBoundingClientRect();
      const linkRect = link.getBoundingClientRect();
      if (linkRect.left >= listRect.left && linkRect.right <= listRect.right) return;

      const left =
        list.scrollLeft +
        linkRect.left -
        listRect.left -
        listRect.width / 2 +
        linkRect.width / 2;
      list.scrollTo({ left, behavior: "smooth" });
    };

    const setActive = (id, centerLink = true) => {
      if (!id || id === activeId) return;
      activeId = id;

      links.forEach((link) => {
        const isActive = link.dataset.anchorLink === id;
        link
          .closest(".zq-product-anchor-nav__item")
          ?.classList.toggle("active", isActive);
        if (isActive) {
          link.setAttribute("aria-current", "true");
          if (centerLink) centerActiveLink(link);
        } else {
          link.removeAttribute("aria-current");
        }
      });
    };

    const updateActiveSection = () => {
      frameRequested = false;
      const { headerOffset, navGap } = updateMeasurements();
      const marker = headerOffset + navGap + nav.offsetHeight + 28;
      let current = sections[0];

      sections.forEach((contentSection) => {
        if (contentSection.getBoundingClientRect().top <= marker) {
          current = contentSection;
        }
      });

      setActive(current.id);
    };

    const requestUpdate = () => {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(updateActiveSection);
    };

    const scrollToSection = (target, behavior = "smooth") => {
      const { headerOffset, navGap } = updateMeasurements();
      const top =
        window.scrollY +
        target.getBoundingClientRect().top -
        headerOffset -
        navGap -
        nav.offsetHeight -
        16;

      window.scrollTo({ top: Math.max(0, top), behavior });
    };

    links.forEach((link) => {
      link.addEventListener(
        "click",
        (event) => {
          const target = document.getElementById(link.dataset.anchorLink);
          if (!target) return;

          event.preventDefault();
          setActive(target.id);
          scrollToSection(target);

          try {
            window.history.replaceState(null, "", `#${target.id}`);
          } catch (error) {
            // Hash updates are optional; scrolling still works when history is unavailable.
          }
        },
        { signal }
      );
    });

    window.addEventListener("scroll", requestUpdate, { passive: true, signal });
    window.addEventListener("resize", requestUpdate, { passive: true, signal });

    if ("ResizeObserver" in window) {
      const resizeObserver = new ResizeObserver(requestUpdate);
      resizeObserver.observe(nav);
      const stickyHeader = document.getElementById("header-sticky");
      if (stickyHeader) resizeObserver.observe(stickyHeader);
      signal.addEventListener("abort", () => resizeObserver.disconnect(), { once: true });
    }

    const hashId = window.location.hash
      ? decodeURIComponent(window.location.hash.slice(1))
      : "";
    const hashTarget = sections.find((contentSection) => contentSection.id === hashId);

    setActive(hashTarget?.id || sections[0].id, false);
    updateActiveSection();

    if (hashTarget) {
      window.setTimeout(() => scrollToSection(hashTarget, "auto"), 0);
    }
  };

  const initLegacyTabs = (root = document) => {
    root
      .querySelectorAll(".bls__product-tabs:not(.bls__product-tabs--anchor)")
      .forEach((tabSection) => {
        tabSection.querySelectorAll(".nav-tabs a").forEach((tabToggle) => {
          if (tabToggle.dataset.legacyTabInitialized === "true") return;
          tabToggle.dataset.legacyTabInitialized = "true";

          tabToggle.addEventListener("click", (event) => {
            event.preventDefault();
            const tabId = tabToggle.getAttribute("data-block-id");
            const target = tabId ? document.getElementById(tabId) : null;
            if (
              !target ||
              tabToggle.closest(".data.item")?.classList.contains("active")
            ) {
              return;
            }

            tabSection.querySelectorAll(".data.item").forEach((item) => {
              item.classList.remove("active");
            });
            tabSection.querySelectorAll(".tab-content .tab-item").forEach((item) => {
              item.classList.remove("active");
              const panel = item.querySelector(".tab-panel");
              if (panel) panel.style.display = "none";
            });

            target.classList.add("active");
            const panel = target.querySelector(".tab-panel");
            if (panel) panel.style.display = "block";
            tabToggle.closest(".data.item")?.classList.add("active");
          });
        });
      });
  };

  const init = (root = document) => {
    const sections = [];
    if (root.matches?.(anchorSectionSelector)) sections.push(root);
    root
      .querySelectorAll?.(anchorSectionSelector)
      .forEach((section) => sections.push(section));
    sections.forEach(initAnchorNavigation);
    initLegacyTabs(root);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
  document.addEventListener("shopify:section:unload", (event) => {
    event.target.querySelector(anchorSectionSelector)?.__zqProductAnchorController?.abort();
  });
})();
